import { ReasonCode } from '../cancel-shift-modal/cancel-shift-modal.ctrl';
import moment from 'moment-timezone';
import editShiftErrorModal from '../edit-shift-status-modals/edit-error-modal.html';
import editShiftErrorModalCtrl from '../edit-shift-status-modals/edit-error-modal.ctrl';
import editShiftSuccessModal from '../edit-shift-status-modals/edit-success-modal.html';
import editShiftSuccessModalCtrl from '../edit-shift-status-modals/edit-success-modal.ctrl';

class EndAssignmentModalController {
  /* @ngInject */
  constructor ($mdDialog, $window, Jobs, user, userJobs, timezone, jobShiftsCount) {
    this.$mdDialog = $mdDialog;
    this.$window = $window;
    this.Jobs = Jobs;
    this.timezone = timezone;
    this.user = user;
    this.userJobs = userJobs;
    this.jobShiftsCount = jobShiftsCount;
    this.dropdownOptions = [
      {
        label: 'Job description or details changed',
        value: ReasonCode.JOB_DESCRIPTION_OR_DETAILS_CHANGED
      },
      {
        label: 'Start/end date changed',
        value: ReasonCode.START_OR_END_DATE_CHANGED
      },
      { label: 'Schedule changed', value: ReasonCode.SCHEDULE_CHANGED },
      { label: 'No longer needed', value: ReasonCode.NO_LONGER_NEEDED },
      { label: 'Other', value: ReasonCode.OTHER }
    ];
  }

  showEndAssignmentSuccessModal = ({ job }) => {
    const parentEl = document.body;
    const userName = this.user.fullname;
    const numberOfShifts = this.jobShiftsCount;
    const shift = this.jobShiftsCount > 1 ? 'shifts' : 'shift';
    return this.$mdDialog.show({
      parent: parentEl,
      fullscreen: true,
      template: editShiftSuccessModal,
      locals: {
        title: 'Assignment ended',
        bodyText: `You have removed ${numberOfShifts} ${shift} for ${userName}.`
      },
      controller: editShiftSuccessModalCtrl,
      controllerAs: 's',
    });
  }

  showErrorModal = (error) => {
    const parentEl = document.body;
    const errorMessage = error?.data?.message ?? 'Please try again.';
    return this.$mdDialog.show({
      parent: parentEl,
      fullscreen: true,
      template: editShiftErrorModal,
      controller: editShiftErrorModalCtrl,
      controllerAs: 'e',
        locals:{
            message: errorMessage,
        },
    });
  }

  onEndAssignment = ({ reasonCode, otherReasonCode, job }) => {
    const assignmentStartDay = moment.tz(job.start_date_time, this.timezone);
    const today = moment().tz(this.timezone);
    const assignmentStarted = assignmentStartDay.isBefore(today);
    const jobId = job.jobId;
    const workerId = this.user.id;
    const reason = this.dropdownOptions.find(rc => rc.value === reasonCode);
    const reasonText = otherReasonCode || reason.label;
    const endDate = moment.tz(this.timezone).valueOf();
    if (assignmentStarted) {
      this.Jobs.changeAssignmentDateRange({ jobId, workerId, endDate, reasonCode, reasonText })
      .then(() => {
        this.showEndAssignmentSuccessModal({ job });
        // Refresh the page to get new roster shifts info
        this.$window.location.reload();
      })
      .catch((error) => {
          this.showErrorModal(error)
      });
    } else {
      this.Jobs.endAssignmentPreStart({reasonCode, reasonText, jobId, workerId})
      .then(() => {
        this.showEndAssignmentSuccessModal({ job });
        // Refresh the page to get new roster shifts info
        this.$window.location.reload();
      })
      .catch((error) => {
          this.showErrorModal(error)
      });
    }

    this.onClose();
  }

  onClose = () => {
    this.$mdDialog.cancel();
  }
}

export default EndAssignmentModalController;
